import type { CategoryNode } from "@/lib/types/product";

export type CategoryOption = { id: number; label: string };

export function flattenCategories(
  nodes: CategoryNode[],
  depth = 0,
): CategoryOption[] {
  const out: CategoryOption[] = [];
  for (const n of nodes) {
    const pad = depth > 0 ? `${"— ".repeat(depth)}` : "";
    out.push({ id: n.id, label: `${pad}${n.name}` });
    if (n.children?.length) {
      out.push(...flattenCategories(n.children, depth + 1));
    }
  }

  return out;
}
